<template>
  <div>
    <create
      @closePopup="createDialog = false"
      @createData="create($event)"
      @getShcools="getSchoolIems($event)"
      :schoolItems="schoolItems"
      :dialog="createDialog"
      :loader="createLoader"
    />
    <edit
      @closePopup="editDialog = false"
      @editData="edit($event)"
      @getShcools="getSchoolIems($event)"
      :schoolItems="schoolItems"
      :dialog="editDialog"
      :dialogData="dialogData"
      :loader="showLoader"
    />
    <delete-popup
      @closePopup="deleteDialog = false"
      @deleteData="deleteItem($event)"
      :dialog="deleteDialog"
      :item="deleteDialogData"
      :loader="deleteLoader"
    />
    <v-row class="mb-4">
      <v-col class="d-flex justify-end"
        ><v-btn color="primary" @click="createAble"
          ><span style="color: white;">{{ $t("add") }}</span></v-btn
        ></v-col
      >
    </v-row>
    <data-table
      @updatePage="getData($event)"
      :headers="tableData.headers"
      :data="tableData.data"
      :editable="editAble"
      :deleteable="deleteAble"
      :loader="loader"
      :meta="pagination"
    />
  </div>
</template>
<script>
import { Educational } from "@/store/common/educational_level";
import { Semester } from "@/store/common/semester";
import dataTable from "@/components/mycomponent/base/dataTable.vue";
import create from "./create.vue";
import edit from "./edit.vue";
import deletePopup from "@/pages/Dashboard/age-group/delete.vue";
export default {
  components: {
    dataTable,
    create,
    edit,
    deletePopup,
  },
  data() {
    return {
      Educational,
      Semester,
      createDialog: false,
      editDialog: false,
      dialogData: null,
      deleteDialog: false,
      deleteDialogData: null,
      schoolItems: [],
    };
  },
  methods: {
    getData(page) {
      let params = {
        page: page,
      };
      Educational.get(params);
      this.dialog = false;
    },
    async getSchoolIems(params) {
      await Semester.get(params);
      this.schoolItems = this.schoolItems.concat(this.shcoolData);
    },

    //create
    createAble() {
      this.createDialog = true;
    },
    async create(data) {
      await Educational.post(data);
      this.createDialog = false;
    },

    //edit
    async editAble(obj) {
      this.editDialog = true;
      await Educational.show(obj.id);
      this.dialogData = Educational.tableData.showData;
    },
    async edit(data) {
      await Educational.edit(data.data, data.id);
      this.editDialog = false;
    },

    //delete
    deleteAble(obj) {
      this.deleteDialog = true;
      this.deleteDialogData = obj;
    },
    async deleteItem(id) {
      await Educational.deleteItem(id);
      this.deleteDialog = false;
    },
  },
  computed: {
    //data
    tableData() {
      return Educational.tableData;
    },
    shcoolData() {
      return Semester.tableData.data;
    },
    pagination() {
      return Educational.tableData.meta;
    },
    //loaders
    loader() {
      return Educational.getState.loading;
    },
    createLoader() {
      return Educational.postState.loading;
    },
    editLoader() {
      return Educational.editState.loading;
    },
    showLoader() {
      return Educational.showState.loading;
    },
    deleteLoader() {
      return Educational.deleteState.loading;
    },
  },
  mounted() {
    this.getData(1);
  },
};
</script>
